import Vue from 'vue';
import VueRouter from 'vue-router';
import Meta from 'vue-meta'
Vue.use(VueRouter);
Vue.use(Meta);

// store
import store from './store';

// App Components
import PageController from '@/components/PageController.vue';

const baseUrl = store.getters.getBaseUrl;

const router = new VueRouter({
  mode: 'history',
  fallback: false,
  routes: [
    {
      path: baseUrl,
      redirect: baseUrl+'page/1/index.html'
    },
    {
      path: baseUrl+'page/:pageid',
      name: 'PageControllerRender',
      component: PageController
    },
    {
      path: baseUrl+'page/:pageid/index.html',
      name: 'PageController',
      component: PageController
    },
    {
      path: '*',
      redirect: baseUrl+'page/1/index.html'
    }
  ]
});

router.beforeEach((to, from, next) => {
  
  if (from.name == null) {
    next();
    return;    
  }

  const navigating = store.getters.getNavigatingPages;
  if (navigating) {
    next();
    return;
  }
  

  // const readingContent = await store.dispatch('closeReadingPane');

  const readingContent = store.getters.getReadingContent;
  if (readingContent) {
    store.commit('setReadingContent', false);
    store.commit('setCloseContent', true);
    next(false);
    return;
  }

  if (to.name === 'PageController' && from.name === 'PageController') {

    let direction = -1;
    if (parseInt(to.params.pageid) > parseInt(from.params.pageid)) {
      direction = 1;
    }
    store.commit('setPageDirection', direction);
  }
  
  next();

})

export default router;